/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import { Swiper, Navigation, EffectCoverflow } from 'swiper/dist/js/swiper.esm.js'
Swiper.use([Navigation, EffectCoverflow])

$(function () {
  // content-swipers
  let contentSwipers = []
  const contentSwiperElements = $('.swiper-container.content-swiper')
  contentSwiperElements.each(function (index, swiper) {
    const slidesAmount = $(swiper).find('.swiper-slide:not(.swiper-slide-duplicate)').length
    let looping = true
    if (slidesAmount < 2) {
      // dont loop if less than 2 slides
      looping = false
    }
    contentSwipers[index] = new Swiper(swiper, {
      effect: 'coverflow',
      spaceBetween: 150,
      centeredSlides: true,
      watchOverflow: true,
      loop: looping,
      slidesPerView: 'auto',
      coverflowEffect: {
        rotate: 12,
        slideShadows: false
      },
      navigation: {
        nextEl: $(swiper).children('.swiper-button-next'),
        prevEl: $(swiper).children('.swiper-button-prev')
      }
    })
  })

  // logo-swiper
  let logoSwipers = []
  const logoSwiperElements = $('.swiper-container.logo-swiper')
  logoSwiperElements.each(function (index, swiper) {
    const slides = $(swiper).find('.swiper-slide').length
    let slidesPerViewVar = 5
    if (slides < 5) {
      slidesPerViewVar = slides
    }
    logoSwipers[index] = new Swiper(swiper, {
      slidesPerView: slidesPerViewVar,
      initialSlide: 0,
      spaceBetween: 40,
      breakpoints: {
        600: {
          slidesPerView: 2,
          spaceBetween: 20
        },
        800: {
          slidesPerView: 4,
          spaceBetween: 20
        }
      },
      autoplay: {
        delay: 2000
      },
      speed: 1000,
      loop: true,
      navigation: {
        nextEl: $(swiper).siblings('.swiper-button-next'),
        prevEl: $(swiper).siblings('.swiper-button-prev')
      }
    })
  })

  // feedback-swiper
  let feedbackSwipers = []
  const feedbackSwiperElement = $('.swiper-container.feedback-swiper')

  feedbackSwiperElement.each(function (index, swiper) {
    feedbackSwipers[index] = new Swiper(swiper, {
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      },
      loop: true,
      pagination: {
        el: $(swiper).siblings('.swiper-pagination'),
        clickable: true
      }
    })
  })
})
